//https://v5.reactrouter.com/web/example/query-parameters

import React from 'react';
import { useLocation } from 'react-router-dom';

// useQueryStringFromUrl
export default function useQuery() {
  const {search} = useLocation();
  return React.useMemo(() => new URLSearchParams(search), [search]);
}